// DS: IL11.5
import React from 'react';

export const Exclusives: React.FC = () => {
  return (
    <img
      alt=""
      src="https://st.deviantart.net/eclipse/global/svg/il11-5.svg"
      width="140"
      height="140"
    />
  );
};
Exclusives.displayName = 'Exclusives';
